<template>
  <label style="cursor: pointer;">
    <input :value="value" :name="name" :type="type" :checked="checked" />
    <slot>{{ title }}</slot>
  </label>
</template>
<script>
import $ from "jquery";
window.jQuery = $;
require("icheck/skins/all.css");
export default {
  name: "pdkCheckBox",
  props: {
    title: { type: String, default: "" },
    type: { type: String, default: "checkbox" },
    name: { type: String, default: "" },
    value: { type: String, default: "" },
    checked: { type: Boolean, default: false },
  },
  mounted: function () {
    const vm = this;
    require("icheck");
    $(vm.$el.querySelector("input")).iCheck({
      checkboxClass: "icheckbox_square-grey",
      radioClass: "iradio_square-grey",
    });

    $(vm.$el.querySelector("input")).on("ifChecked", () => {
      vm.$emit("change", vm.value);
    });

    if (vm.type === "checkbox") {
      $(vm.$el.querySelector("input")).on("ifUnchecked", () => {
        vm.$emit("change", undefined);
      });
    }
  },
};
</script>